import { html, TemplateResult } from "lit";
import { InputField } from "./inputField";
import { FieldInputEvent } from "@lib/types";

/** Input field template. */
export function inputFieldTemplate(this: InputField): TemplateResult {
    return html`
        <fw-input
            .class=${this.class}
            .type=${this.type}
            .label=${this.label}
            .value="${this.value}"
            .errorText=${this.errorText}
            .state=${this.state}
            .disabled=${this.disabled}
            @fwInput="${(event: FieldInputEvent) => {
                this.onFieldInput(event);
            }}"
        ></fw-input>
    `;
}
